'use client'

import { useOptimistic, useTransition } from 'react'
import { toggleFav } from '../providers/server'

export function useToggleFav(initialValue: boolean, productSlug: string) {
  const [isPending, startTransition] = useTransition()

  const [optimisticFav, toggleOptimisticFav] = useOptimistic(
    initialValue,
    (state, newValue: boolean) => newValue,
  )
  const handleToggle = () => {
    startTransition(async () => {
      toggleOptimisticFav(!optimisticFav)
      try {
        await toggleFav(productSlug)
      } catch (error) {
        toggleOptimisticFav(optimisticFav)
        console.error('Failed to toggle favorite:', error)
      }
    })
  }

  return { isFav: optimisticFav, isPending, toggle: handleToggle }
}
